module.exports = __webpack_public_path__ + "static/img/1_03.d4939580.png";